// NATIVE
import React from 'react';
import { useSelector } from 'react-redux';

// INSTALLED
import { styled } from '@mui/material/styles';
import { Checkbox, FormControl, FormControlLabel, Grid, TextField } from '@mui/material';

// CUSTOM

export const DetailCargo = (props: any) => {
  // USE SELECTOR
  const { cargo, cargos_list }: any = useSelector((state: any) => state.cargos);

  // USE EFFECT
  const [dataCargo, setDataCargo] = React.useState<any>(null);
  const [areas_select, setAreasSelect] = React.useState([]);

  // USE EFFECT
  React.useEffect(() => {
    setDataCargo(cargo);
  }, [cargo]);

  React.useEffect(() => {
    const cargos: any = [];

    for (let index = 0; index < cargos_list.length; index++) {
      const data = {
        label: cargos_list[index].name,
        value: cargos_list[index].id,
      };
      cargos.push(data);
    }
    setAreasSelect(cargos);
  }, [cargos_list]);

  // CONST STYLE
  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
  }));

  return (
    <div>
      {dataCargo && (
        <>
          <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
              <TextField
                fullWidth
                name={dataCargo.name}
                label={'Area'}
                defaultValue={dataCargo.name}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
          <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
              <TextField
                fullWidth
                multiline
                rows={5}
                name={dataCargo.description}
                label={'Descripcion'}
                defaultValue={dataCargo.description}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
          <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
              <TextField
                fullWidth
                name={dataCargo.area.name}
                label={'Area'}
                defaultValue={dataCargo.area.name}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'visita_domiciliaria'}
                        checked={dataCargo.visita_domiciliaria ? true : false}
                      />
                    }
                    label={'visita domiciliaria'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'prueba_psicotecnica'}
                        checked={dataCargo.prueba_psicotecnica ? true : false}
                      />
                    }
                    label={'prueba psicotecnica'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'examen_alimentos'}
                        checked={dataCargo.examen_alimentos ? true : false}
                      />
                    }
                    label={'examen alimentos'}
                  />
                </FormControl>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'examen_alturas'}
                        checked={dataCargo.examen_alturas ? true : false}
                      />
                    }
                    label={'examen alturas'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'certificado_laboral'}
                        checked={dataCargo.certificado_laboral ? true : false}
                      />
                    }
                    label={'certificado laboral'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'certificado_estudios'}
                        checked={dataCargo.certificado_estudios ? true : false}
                      />
                    }
                    label={'certificado estudios'}
                  />
                </FormControl>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={<Checkbox name={'adres'} checked={dataCargo.adres ? true : false} />}
                    label={'adres'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'antecedentes_judicial'}
                        checked={dataCargo.antecedentes_judicial ? true : false}
                      />
                    }
                    label={'antecedentes judicial'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox name={'entrevista'} checked={dataCargo.entrevista ? true : false} />
                    }
                    label={'entrevista'}
                  />
                </FormControl>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'sociodemografica'}
                        checked={dataCargo.sociodemografica ? true : false}
                      />
                    }
                    label={'sociodemografica'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={<Checkbox name={'dme'} checked={dataCargo.dme ? true : false} />}
                    label={'dme'}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControl>
                  <FormControlLabel
                    control={<Checkbox name={'sst'} checked={dataCargo.sst ? true : false} />}
                    label={'sst'}
                  />
                </FormControl>
              </div>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};
